
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reports/department/[departmentId]",
      function () {
        return require("private-next-pages/reports/department/[departmentId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reports/department/[departmentId]"])
      });
    }
  